"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHasIncompatibleSources = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    // hasIncompatibleSources is set to true if we try to load json sources in
    // CDO Blockly, which only supports xml.
    hasIncompatibleSources: false,
};
var blocklySlice = (0, toolkit_1.createSlice)({
    name: 'blockly',
    initialState: initialState,
    reducers: {
        setHasIncompatibleSources: function (state, action) {
            state.hasIncompatibleSources = action.payload;
        },
    },
});
exports.setHasIncompatibleSources = blocklySlice.actions.setHasIncompatibleSources;
exports.default = blocklySlice.reducer;
